import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["table", "cards", "deck", "toggleButton", "deckPanel", "deckToggleButton"]
  static values = { decks: Array }

  CARDS_PER_PAGE = 8

  connect() {
    this.activeDeckIndex = 0
    this.deckCards = this.decksValue.map(deck => [...deck.cards])
    this.showFaces = true
    this.initEvents()
    this.renderCards()
  }

  initEvents() {
    this.deckTargets.forEach((el, index) => {
      el.addEventListener("click", () => {
        this.deckTargets.forEach(d => d.classList.remove("active"))
        el.classList.add("active")
        this.activeDeckIndex = index
        this.renderCards()
      })
    })

    $(this.tableTarget).droppable({
      accept: ".card",
      drop: (event, ui) => {
        const cardIndex = $(ui.draggable).data("index")
        const card = this.deckCards[this.activeDeckIndex][cardIndex]
        if (card) {
          const offset = $(this.tableTarget).offset()
          const x = ui.offset.left - offset.left
          const y = ui.offset.top - offset.top
          this.addCardToTable(card, x, y)
          this.deckCards[this.activeDeckIndex].splice(cardIndex, 1)
          this.renderCards()
        }
      }
    })

    this.deckTargets[0]?.click()
  }

  renderCards() {
    $(this.cardsTarget).empty()

    const deck = this.decksValue[this.activeDeckIndex]
    const cards = this.deckCards[this.activeDeckIndex]

    const pages = []
    for (let i = 0; i < cards.length; i += this.CARDS_PER_PAGE) {
      pages.push(cards.slice(i, i + this.CARDS_PER_PAGE))
    }

    pages.forEach((pageCards, pageIndex) => {
      const pageEl = $(`
      <div class="carousel-item ${pageIndex === 0 ? "active" : ""}">
        <div class="cards-page"></div>
      </div>
    `)

      pageCards.forEach((card, i) => {
        const realIndex = pageIndex * this.CARDS_PER_PAGE + i

        const innerHtml = this.showFaces
          ? this.cardFaceUpHTML(card)
          : this.cardFaceDownHTML(deck)

        const cardEl = $(`
        <div class="card shadow-sm text-center d-flex align-items-center justify-content-center"
             data-index="${realIndex}"
             style="width: 120px; height: 160px; cursor: grab;">
          ${innerHtml}
        </div>
      `)

        cardEl.draggable({ revert: "invalid", helper: "clone" })
        pageEl.find(".cards-page").append(cardEl)
      })

      $(this.cardsTarget).append(pageEl)
    })
  }


  // renderCards() {
  //   $(this.cardsTarget).empty()
  //   const deck = this.decksValue[this.activeDeckIndex]
  //   const cards = this.deckCards[this.activeDeckIndex]
  //
  //   cards.forEach((card, i) => {
  //     const innerHtml = this.showFaces
  //         ? this.cardFaceUpHTML(card)
  //         : this.cardFaceDownHTML(deck)
  //
  //     const cardEl = $(`
  //     <div class="card shadow-sm text-center d-flex flex-column justify-content-center align-items-center"
  //          data-index="${i}"
  //          style="width: 120px; height: 160px; background: "transparent"; cursor: grab;">
  //       ${innerHtml}
  //     </div>
  //   `)
  //
  //     cardEl.draggable({ revert: "invalid", helper: "clone" })
  //     $(this.cardsTarget).append(cardEl)
  //   })
  // }

  // cardFaceUpHTML(card) {
  //   return `<img src="${card.image_url}" style="max-width: 120px; max-height: 160px; object-fit: cover; cursor: grab;" class="mb-1" />`
  // }

  cardFaceUpHTML(card) {
    return `
    <img src="${card.image_url}"
         class="w-100 h-100"
         style="object-fit: cover; cursor: grab;" />
  `
  }

  cardFaceDownHTML(deck) {
    return `<img src="${deck.cover_url}" class="img-fluid rounded" style="width: 100%; height: 100%; object-fit: cover; cursor: grab;" />`
  }

  addCardToTable(card, x, y) {
    const deck = this.decksValue[this.activeDeckIndex];
    let faceDown = !this.showFaces;

    const cardContainer = $(`
      <div class="position-absolute d-flex flex-column align-items-center justify-content-center text-white rounded shadow"
           style="width: 120px; height: 160px; top: ${y}px; left: ${x}px; cursor: move;">
      </div>
    `);

    const contentWrapper = $('<div class="position-relative w-100 h-100 d-flex flex-column justify-content-center align-items-center"></div>');

    const controlsWrapper = $(`
      <div class="position-absolute d-flex flex-column gap-1"
           style="top: -14px; right: -14px; z-index: 10;">
      </div>
    `);

    const flipButton = $(`
      <button class="btn btn-sm btn-light"
              style="border-radius: 50%; width: 32px; height: 32px; box-shadow: 0 0 4px rgba(0,0,0,0.2);">
        <i class="bi bi-arrow-repeat"></i>
      </button>
    `);

    const removeButton = $(`
      <button class="btn btn-sm btn-danger"
              style="border-radius: 50%; width: 32px; height: 32px; box-shadow: 0 0 4px rgba(0,0,0,0.2);">
        <i class="bi bi-trash-fill"></i>
      </button>
    `);

    const updateCardContent = () => {
      contentWrapper.empty();
      const innerHtml = faceDown
          ? this.cardFaceDownHTML(deck)
          : this.cardFaceUpHTML(card);

      contentWrapper.append(innerHtml);
      controlsWrapper.empty().append(flipButton, removeButton);
      contentWrapper.append(controlsWrapper);

      // Flip behavior
      flipButton.on("click", (e) => {
        e.stopPropagation();
        faceDown = !faceDown;
        updateCardContent();
      });

      // Remove behavior
      removeButton.on("click", (e) => {
        e.stopPropagation();
        cardContainer.remove();
        this.deckCards[this.activeDeckIndex].push(card);
        this.renderCards();
      });
    };

    cardContainer.draggable({ containment: this.tableTarget });

    updateCardContent();
    cardContainer.append(contentWrapper);
    $(this.tableTarget).append(cardContainer);
  }

  shuffleDeck() {
    const deckIndex = this.activeDeckIndex;
    const currentDeck = this.deckCards[deckIndex];

    // Only shuffle cards that are NOT on the table
    const tableCardIndexes = [...this.tableTarget.children]
        .map(el => parseInt(el.dataset.index))
        .filter(n => !isNaN(n));

    const availableCards = currentDeck
        .map((card, i) => ({ card, index: i }))
        .filter(({ index }) => !tableCardIndexes.includes(index));

    // Shuffle them

    for (let i = availableCards.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [availableCards[i], availableCards[j]] = [availableCards[j], availableCards[i]];
    }
    // Re-insert shuffled cards back into original positions
    const shuffled = [...currentDeck];
    availableCards.forEach(({ index }, i) => {
      shuffled[i] = availableCards[index].card;
    });

    this.deckCards[deckIndex] = shuffled;
    // debugger


    // Re-render card list
    this.renderCards();
  }

  toggleFaces() {
    this.showFaces = !this.showFaces

    // Update button text
    if (this.hasToggleButtonTarget) {
      this.toggleButtonTarget.textContent = this.showFaces ? "Show Covers" : "Show Faces"
    }

    // Rerender only available cards
    this.renderCards()
  }

  toggleDecks() {
    const isVisible = this.deckPanelTarget.style.display !== "none";

    this.deckPanelTarget.style.display = isVisible ? "none" : "block";
    this.deckToggleButtonTarget.style.right = isVisible ? '5px' : '150px'

    const icon = this.deckToggleButtonTarget.querySelector("i");
    if (icon) {
      icon.className = isVisible ? "bi bi-chevron-left" : "bi bi-chevron-right";
      icon.right = 0
    }
  }
}
